import { DragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { compose } from 'recompose';
import { prop } from 'ramda';
import withLifecycle from '@hocs/with-lifecycle';

import { IInner, IOuter } from './DragSource.types';

export const enhance = compose<IInner, IOuter>(
  DragSource<IOuter>(
    prop('type'),
    {
      beginDrag: ({ beginDrag, item }) => beginDrag(item),
      canDrag: ({ disabled }) => !disabled,
    },
    (connect) => ({
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
    }),
  ),
  withLifecycle({
    onDidMount({ connectDragPreview }) {
      if (connectDragPreview) {
        // Use empty image as a drag preview so browsers don't draw it
        // and we can draw whatever we want on the custom drag layer instead.
        connectDragPreview(getEmptyImage(), {
          // IE fallback: specify that we'd rather screenshot the node
          // when it already knows it's being dragged so we can hide it with CSS.
          captureDraggingState: true,
        });
      }
    },
  }),
);
